import firebase from "js/firebase";
import { openWindowAndWaitForItToBeClosed } from "js/core/utilities/selfClosingWindow";

export class OneDriveAuthError extends Error { }
export class OneDriveAuthFlowWasInterruptedError extends OneDriveAuthError { }

interface OneDriveAuthTokens {
    accessToken: string,
    idToken: string,
}

export const SCOPES = ["openid", "profile", "offline_access", "User.Read", "Files.Read.All"];

/**
 * Grants our app offline access for the given scope, executes the redirect ouath flow in a separate window
 * and saves the tokens
 */
export async function grantOfflineAccess(): Promise<OneDriveAuthTokens> {
    const userIdToken = await firebase.auth().currentUser.getIdToken();

    const url = `${window.location.origin}/oneDrive/auth` +
        `?continueUrl=${encodeURIComponent("/close")}` +
        `&userIdToken=${encodeURIComponent(userIdToken)}` +
        "&requestOfflineAccess=true";

    const lastSearchParams = await openWindowAndWaitForItToBeClosed(url);

    if (lastSearchParams.has("onedrive_auth_error")) {
        throw new OneDriveAuthError(lastSearchParams.get("onedrive_auth_error"));
    }

    if (lastSearchParams.get("onedrive_auth_success") !== "true") {
        throw new OneDriveAuthFlowWasInterruptedError();
    }

    const accessToken = lastSearchParams.get("onedrive_auth_access_token");
    const idToken = lastSearchParams.get("onedrive_auth_id_token");

    return { accessToken, idToken };
}
